import { createReportEventUnauthenticatedParams, PropertiesType,ReportEventUnauthenticatedParams  } from '@tableau/typescript-telemetry-forwarder';

import * as _ from 'underscore';

/**
 * Deprecated way of sending events, see TelemetryService instead.
 * Usage examples: UrlTelemetryService.ts for Angular and SiteSpace.tsx for React
 */
export class DeprecatedEventWrapper {

  public static eventTypes = {
    'GettingStarted': 'getting_started_event',
    'InfoMenu_SearchHelp': 'InfoMenu_SearchHelp',
    'VisitAlertFromEmail': 'VisitAlertFromEmail',
    // for new events see https://mytableau.tableaucorp.com/display/devcomm/VizPortal+Client+telemetry+events
  };

  constructor(
      private sendTelemetryEvent: (params: ReportEventUnauthenticatedParams) => void,
      private serviceName: string,
      private userId: string,
      private siteId: string,
      private browserInfo: string) {}

  public sendEvent(type: string, action: string, context?: object, extraProperties?: _.Dictionary<string>): void {
    const analyticsProperties: PropertiesType = {
      'action': action,
      'user_id': this.userId,
      'site_id': this.siteId,
      'browser_info': this.browserInfo,
    };

    if (context) {
      analyticsProperties.context = JSON.stringify(context);
    }

    _.each(extraProperties, (value, key) => {
      analyticsProperties[key] = value;
    });

    // java-event-client use NetworkUtilities.getHostName() to get hostName, so we do not need to add hostName
    // https://gitlab.tableausoftware.com/Product-Analytics/java-event-client/blob/master/src/main/java/com/tableau/telemetry/event/AEvent.java#L27
    const params: ReportEventUnauthenticatedParams = createReportEventUnauthenticatedParams(type,this.serviceName ,analyticsProperties);
    this.sendTelemetryEvent(params);
  }

  public sendFromEmailEvent(
      type: string,
      alertEvaluationState: string,
      alertId: string,
      viewId: string,
      workbookId: string,
      siteRole: string): void {

      const properties: PropertiesType = {
        'user_id': this.userId,
        'site_id': this.siteId,
        'browser_info': this.browserInfo,
        'alert_evaluation_state': alertEvaluationState,
        'alert_id': alertId,
        'view_id': viewId,
        'workbook_id': workbookId,
        'site_role': siteRole,
      };
      const params: ReportEventUnauthenticatedParams = createReportEventUnauthenticatedParams(type, this.serviceName , properties);
      this.sendTelemetryEvent(params);
  }

  public sendGettingStartedEvent(action: string, targetText: string, context: string = ''): void {
    const properties: PropertiesType = {
      'action': action,
      'user_id': this.userId,
      'site_id': this.siteId,
      'target_text': targetText,
      'context': context,
    };

    const params: ReportEventUnauthenticatedParams = createReportEventUnauthenticatedParams(DeprecatedEventWrapper.eventTypes.GettingStarted, this.serviceName , properties);

    this.sendTelemetryEvent(params);
  }
}

